const CompanyUser = {

    // FIELDS
    "company_user": "Company User",
    "company": "Company",
    "user": "User",
    "name": "Name",
    "user_name": "User Name",
    "first_name": "First Name",
    "last_name": "Last Name",
    "password": "Password",
    "email": "Email",
    "phone": "Phone",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "Company User",
    "filter_title": "Company User Filter",

    // TABLE HEADER
    "table_name": "NAME",
    "table_company": "COMPANY NAME",
    "table_user": "USER NAME",
    "table_role": "ROLE",
    "table_email": "EMAIL",
    "table_phone": "PHONE",

    // ERROR
    "error_company": "Select Company",
    "error_user": "Select User",
    "error_name": "Enter Name",
    "error_user_name": "Enter User Name",
    "error_first_name": "Enter First Name",
    "error_last_name": "Enter Last Name",
    "error_password": "Enter Password",
    "error_email": "Enter Email",
    "error_phone": "Enter Phone",
    "error_status": "Select Status",

}

export default CompanyUser;

